var cov_209l5tj3cs = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/Upload.tsx",
      hash = "bfc8892f0e152ad548a3aaab3611aaef28d69e75",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/Upload.tsx",
    statementMap: {
      "0": {
        start: {
          line: 25,
          column: 98
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "1": {
        start: {
          line: 26,
          column: 40
        },
        end: {
          line: 26,
          column: 49
        }
      },
      "2": {
        start: {
          line: 30,
          column: 19
        },
        end: {
          line: 30,
          column: 39
        }
      },
      "3": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 31,
          column: 34
        }
      },
      "4": {
        start: {
          line: 34,
          column: 51
        },
        end: {
          line: 34,
          column: 55
        }
      },
      "5": {
        start: {
          line: 37,
          column: 17
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "6": {
        start: {
          line: 38,
          column: 14
        },
        end: {
          line: 38,
          column: 29
        }
      },
      "7": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 39,
          column: 55
        }
      },
      "8": {
        start: {
          line: 39,
          column: 45
        },
        end: {
          line: 39,
          column: 55
        }
      },
      "9": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 43,
          column: 4
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 41
        }
      },
      "11": {
        start: {
          line: 41,
          column: 30
        },
        end: {
          line: 41,
          column: 41
        }
      },
      "12": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 17
        }
      },
      "13": {
        start: {
          line: 53,
          column: 21
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "14": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 16
        }
      },
      "15": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "16": {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 42
        }
      },
      "17": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 50
        }
      },
      "18": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 56
        }
      },
      "19": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 48
        }
      },
      "20": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 50
        }
      },
      "21": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 52
        }
      },
      "22": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 58
        }
      },
      "23": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 52
        }
      },
      "24": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 56
        }
      },
      "25": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 54
        }
      },
      "26": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 48
        }
      },
      "27": {
        start: {
          line: 94,
          column: 26
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "28": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "29": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 35
        }
      },
      "30": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 20
        }
      },
      "31": {
        start: {
          line: 102,
          column: 23
        },
        end: {
          line: 102,
          column: 33
        }
      },
      "32": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 49
        }
      },
      "33": {
        start: {
          line: 103,
          column: 36
        },
        end: {
          line: 103,
          column: 49
        }
      },
      "34": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 104,
          column: 57
        }
      },
      "35": {
        start: {
          line: 104,
          column: 38
        },
        end: {
          line: 104,
          column: 57
        }
      },
      "36": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 13
        }
      },
      "37": {
        start: {
          line: 109,
          column: 37
        },
        end: {
          line: 109,
          column: 47
        }
      },
      "38": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 58
        }
      },
      "39": {
        start: {
          line: 111,
          column: 35
        },
        end: {
          line: 111,
          column: 58
        }
      },
      "40": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 16
        }
      },
      "41": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 22
        }
      },
      "42": {
        start: {
          line: 121,
          column: 25
        },
        end: {
          line: 121,
          column: 35
        }
      },
      "43": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 24
        }
      },
      "44": {
        start: {
          line: 122,
          column: 18
        },
        end: {
          line: 122,
          column: 24
        }
      },
      "45": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 22
        }
      },
      "46": {
        start: {
          line: 127,
          column: 22
        },
        end: {
          line: 127,
          column: 32
        }
      },
      "47": {
        start: {
          line: 128,
          column: 4
        },
        end: {
          line: 131,
          column: 6
        }
      },
      "48": {
        start: {
          line: 129,
          column: 6
        },
        end: {
          line: 129,
          column: 66
        }
      },
      "49": {
        start: {
          line: 129,
          column: 41
        },
        end: {
          line: 129,
          column: 66
        }
      },
      "50": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 19
        }
      },
      "51": {
        start: {
          line: 135,
          column: 44
        },
        end: {
          line: 135,
          column: 54
        }
      },
      "52": {
        start: {
          line: 136,
          column: 17
        },
        end: {
          line: 136,
          column: 37
        }
      },
      "53": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 138,
          column: 64
        }
      },
      "54": {
        start: {
          line: 138,
          column: 46
        },
        end: {
          line: 138,
          column: 64
        }
      },
      "55": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 152,
          column: 5
        }
      },
      "56": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 141,
          column: 54
        }
      },
      "57": {
        start: {
          line: 141,
          column: 38
        },
        end: {
          line: 141,
          column: 54
        }
      },
      "58": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 151,
          column: 7
        }
      },
      "59": {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 144,
          column: 32
        }
      },
      "60": {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 149,
          column: 11
        }
      },
      "61": {
        start: {
          line: 148,
          column: 12
        },
        end: {
          line: 148,
          column: 53
        }
      },
      "62": {
        start: {
          line: 156,
          column: 52
        },
        end: {
          line: 156,
          column: 62
        }
      },
      "63": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 24
        }
      },
      "64": {
        start: {
          line: 157,
          column: 18
        },
        end: {
          line: 157,
          column: 24
        }
      },
      "65": {
        start: {
          line: 158,
          column: 20
        },
        end: {
          line: 158,
          column: 43
        }
      },
      "66": {
        start: {
          line: 159,
          column: 24
        },
        end: {
          line: 159,
          column: 102
        }
      },
      "67": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 175,
          column: 22
        }
      },
      "68": {
        start: {
          line: 162,
          column: 8
        },
        end: {
          line: 169,
          column: 9
        }
      },
      "69": {
        start: {
          line: 164,
          column: 12
        },
        end: {
          line: 164,
          column: 55
        }
      },
      "70": {
        start: {
          line: 165,
          column: 12
        },
        end: {
          line: 167,
          column: 13
        }
      },
      "71": {
        start: {
          line: 166,
          column: 14
        },
        end: {
          line: 166,
          column: 35
        }
      },
      "72": {
        start: {
          line: 170,
          column: 22
        },
        end: {
          line: 172,
          column: 10
        }
      },
      "73": {
        start: {
          line: 171,
          column: 10
        },
        end: {
          line: 171,
          column: 32
        }
      },
      "74": {
        start: {
          line: 173,
          column: 8
        },
        end: {
          line: 173,
          column: 34
        }
      },
      "75": {
        start: {
          line: 179,
          column: 25
        },
        end: {
          line: 179,
          column: 35
        }
      },
      "76": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 24
        }
      },
      "77": {
        start: {
          line: 180,
          column: 18
        },
        end: {
          line: 180,
          column: 24
        }
      },
      "78": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 185,
          column: 5
        }
      },
      "79": {
        start: {
          line: 183,
          column: 8
        },
        end: {
          line: 183,
          column: 25
        }
      },
      "80": {
        start: {
          line: 186,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      },
      "81": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 38
        }
      },
      "82": {
        start: {
          line: 194,
          column: 68
        },
        end: {
          line: 194,
          column: 78
        }
      },
      "83": {
        start: {
          line: 195,
          column: 22
        },
        end: {
          line: 195,
          column: 32
        }
      },
      "84": {
        start: {
          line: 196,
          column: 16
        },
        end: {
          line: 196,
          column: 20
        }
      },
      "85": {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 197,
          column: 13
        }
      },
      "86": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 202,
          column: 5
        }
      },
      "87": {
        start: {
          line: 200,
          column: 24
        },
        end: {
          line: 200,
          column: 48
        }
      },
      "88": {
        start: {
          line: 201,
          column: 6
        },
        end: {
          line: 201,
          column: 89
        }
      },
      "89": {
        start: {
          line: 201,
          column: 22
        },
        end: {
          line: 201,
          column: 89
        }
      },
      "90": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 216,
          column: 5
        }
      },
      "91": {
        start: {
          line: 205,
          column: 19
        },
        end: {
          line: 205,
          column: 36
        }
      },
      "92": {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 214,
          column: 7
        }
      },
      "93": {
        start: {
          line: 207,
          column: 8
        },
        end: {
          line: 212,
          column: 9
        }
      },
      "94": {
        start: {
          line: 209,
          column: 10
        },
        end: {
          line: 209,
          column: 72
        }
      },
      "95": {
        start: {
          line: 211,
          column: 10
        },
        end: {
          line: 211,
          column: 61
        }
      },
      "96": {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 213,
          column: 48
        }
      },
      "97": {
        start: {
          line: 213,
          column: 36
        },
        end: {
          line: 213,
          column: 48
        }
      },
      "98": {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 215,
          column: 12
        }
      },
      "99": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 15
        }
      },
      "100": {
        start: {
          line: 222,
          column: 77
        },
        end: {
          line: 222,
          column: 87
        }
      },
      "101": {
        start: {
          line: 224,
          column: 18
        },
        end: {
          line: 224,
          column: 41
        }
      },
      "102": {
        start: {
          line: 225,
          column: 23
        },
        end: {
          line: 225,
          column: 28
        }
      },
      "103": {
        start: {
          line: 226,
          column: 19
        },
        end: {
          line: 226,
          column: 90
        }
      },
      "104": {
        start: {
          line: 227,
          column: 4
        },
        end: {
          line: 227,
          column: 71
        }
      },
      "105": {
        start: {
          line: 227,
          column: 21
        },
        end: {
          line: 227,
          column: 71
        }
      },
      "106": {
        start: {
          line: 228,
          column: 22
        },
        end: {
          line: 228,
          column: 81
        }
      },
      "107": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 30
        }
      },
      "108": {
        start: {
          line: 229,
          column: 24
        },
        end: {
          line: 229,
          column: 30
        }
      },
      "109": {
        start: {
          line: 230,
          column: 17
        },
        end: {
          line: 230,
          column: 77
        }
      },
      "110": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 302,
          column: 5
        }
      },
      "111": {
        start: {
          line: 232,
          column: 19
        },
        end: {
          line: 232,
          column: 30
        }
      },
      "112": {
        start: {
          line: 233,
          column: 17
        },
        end: {
          line: 233,
          column: 28
        }
      },
      "113": {
        start: {
          line: 234,
          column: 31
        },
        end: {
          line: 239,
          column: 7
        }
      },
      "114": {
        start: {
          line: 241,
          column: 6
        },
        end: {
          line: 241,
          column: 22
        }
      },
      "115": {
        start: {
          line: 243,
          column: 20
        },
        end: {
          line: 243,
          column: 49
        }
      },
      "116": {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 270,
          column: 7
        }
      },
      "117": {
        start: {
          line: 245,
          column: 8
        },
        end: {
          line: 248,
          column: 9
        }
      },
      "118": {
        start: {
          line: 246,
          column: 10
        },
        end: {
          line: 246,
          column: 26
        }
      },
      "119": {
        start: {
          line: 247,
          column: 10
        },
        end: {
          line: 247,
          column: 18
        }
      },
      "120": {
        start: {
          line: 250,
          column: 8
        },
        end: {
          line: 250,
          column: 36
        }
      },
      "121": {
        start: {
          line: 251,
          column: 8
        },
        end: {
          line: 251,
          column: 27
        }
      },
      "122": {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 268,
          column: 9
        }
      },
      "123": {
        start: {
          line: 254,
          column: 10
        },
        end: {
          line: 267,
          column: 30
        }
      },
      "124": {
        start: {
          line: 257,
          column: 14
        },
        end: {
          line: 265,
          column: 15
        }
      },
      "125": {
        start: {
          line: 258,
          column: 16
        },
        end: {
          line: 262,
          column: 17
        }
      },
      "126": {
        start: {
          line: 260,
          column: 20
        },
        end: {
          line: 260,
          column: 78
        }
      },
      "127": {
        start: {
          line: 264,
          column: 16
        },
        end: {
          line: 264,
          column: 62
        }
      },
      "128": {
        start: {
          line: 267,
          column: 25
        },
        end: {
          line: 267,
          column: 29
        }
      },
      "129": {
        start: {
          line: 269,
          column: 8
        },
        end: {
          line: 269,
          column: 16
        }
      },
      "130": {
        start: {
          line: 272,
          column: 6
        },
        end: {
          line: 301,
          column: 7
        }
      },
      "131": {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 298,
          column: 12
        }
      },
      "132": {
        start: {
          line: 276,
          column: 12
        },
        end: {
          line: 276,
          column: 91
        }
      },
      "133": {
        start: {
          line: 276,
          column: 39
        },
        end: {
          line: 276,
          column: 91
        }
      },
      "134": {
        start: {
          line: 277,
          column: 12
        },
        end: {
          line: 285,
          column: 13
        }
      },
      "135": {
        start: {
          line: 278,
          column: 14
        },
        end: {
          line: 282,
          column: 15
        }
      },
      "136": {
        start: {
          line: 280,
          column: 18
        },
        end: {
          line: 280,
          column: 76
        }
      },
      "137": {
        start: {
          line: 284,
          column: 14
        },
        end: {
          line: 284,
          column: 60
        }
      },
      "138": {
        start: {
          line: 289,
          column: 12
        },
        end: {
          line: 297,
          column: 13
        }
      },
      "139": {
        start: {
          line: 290,
          column: 14
        },
        end: {
          line: 294,
          column: 15
        }
      },
      "140": {
        start: {
          line: 292,
          column: 18
        },
        end: {
          line: 292,
          column: 40
        }
      },
      "141": {
        start: {
          line: 296,
          column: 14
        },
        end: {
          line: 296,
          column: 30
        }
      },
      "142": {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 49
        }
      },
      "143": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 303,
          column: 23
        }
      },
      "144": {
        start: {
          line: 304,
          column: 4
        },
        end: {
          line: 304,
          column: 28
        }
      },
      "145": {
        start: {
          line: 320,
          column: 8
        },
        end: {
          line: 320,
          column: 18
        }
      },
      "146": {
        start: {
          line: 322,
          column: 16
        },
        end: {
          line: 322,
          column: 41
        }
      },
      "147": {
        start: {
          line: 323,
          column: 19
        },
        end: {
          line: 323,
          column: 24
        }
      },
      "148": {
        start: {
          line: 325,
          column: 46
        },
        end: {
          line: 400,
          column: 5
        }
      },
      "149": {
        start: {
          line: 338,
          column: 24
        },
        end: {
          line: 338,
          column: 94
        }
      },
      "150": {
        start: {
          line: 339,
          column: 8
        },
        end: {
          line: 339,
          column: 28
        }
      },
      "151": {
        start: {
          line: 339,
          column: 22
        },
        end: {
          line: 339,
          column: 28
        }
      },
      "152": {
        start: {
          line: 340,
          column: 8
        },
        end: {
          line: 340,
          column: 23
        }
      },
      "153": {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 343,
          column: 14
        }
      },
      "154": {
        start: {
          line: 342,
          column: 10
        },
        end: {
          line: 342,
          column: 26
        }
      },
      "155": {
        start: {
          line: 345,
          column: 8
        },
        end: {
          line: 358,
          column: 9
        }
      },
      "156": {
        start: {
          line: 346,
          column: 10
        },
        end: {
          line: 357,
          column: 11
        }
      },
      "157": {
        start: {
          line: 348,
          column: 14
        },
        end: {
          line: 348,
          column: 47
        }
      },
      "158": {
        start: {
          line: 349,
          column: 14
        },
        end: {
          line: 349,
          column: 52
        }
      },
      "159": {
        start: {
          line: 349,
          column: 23
        },
        end: {
          line: 349,
          column: 52
        }
      },
      "160": {
        start: {
          line: 353,
          column: 14
        },
        end: {
          line: 355,
          column: 15
        }
      },
      "161": {
        start: {
          line: 354,
          column: 16
        },
        end: {
          line: 354,
          column: 48
        }
      },
      "162": {
        start: {
          line: 364,
          column: 8
        },
        end: {
          line: 367,
          column: 9
        }
      },
      "163": {
        start: {
          line: 365,
          column: 10
        },
        end: {
          line: 365,
          column: 41
        }
      },
      "164": {
        start: {
          line: 366,
          column: 10
        },
        end: {
          line: 366,
          column: 16
        }
      },
      "165": {
        start: {
          line: 370,
          column: 8
        },
        end: {
          line: 370,
          column: 86
        }
      },
      "166": {
        start: {
          line: 370,
          column: 62
        },
        end: {
          line: 370,
          column: 86
        }
      },
      "167": {
        start: {
          line: 371,
          column: 8
        },
        end: {
          line: 371,
          column: 40
        }
      },
      "168": {
        start: {
          line: 371,
          column: 20
        },
        end: {
          line: 371,
          column: 40
        }
      },
      "169": {
        start: {
          line: 373,
          column: 8
        },
        end: {
          line: 375,
          column: 9
        }
      },
      "170": {
        start: {
          line: 374,
          column: 10
        },
        end: {
          line: 374,
          column: 51
        }
      },
      "171": {
        start: {
          line: 377,
          column: 8
        },
        end: {
          line: 396,
          column: 9
        }
      },
      "172": {
        start: {
          line: 378,
          column: 10
        },
        end: {
          line: 384,
          column: 11
        }
      },
      "173": {
        start: {
          line: 380,
          column: 14
        },
        end: {
          line: 380,
          column: 44
        }
      },
      "174": {
        start: {
          line: 381,
          column: 14
        },
        end: {
          line: 381,
          column: 46
        }
      },
      "175": {
        start: {
          line: 382,
          column: 14
        },
        end: {
          line: 382,
          column: 53
        }
      },
      "176": {
        start: {
          line: 386,
          column: 10
        },
        end: {
          line: 390,
          column: 11
        }
      },
      "177": {
        start: {
          line: 388,
          column: 14
        },
        end: {
          line: 388,
          column: 36
        }
      },
      "178": {
        start: {
          line: 392,
          column: 25
        },
        end: {
          line: 394,
          column: 12
        }
      },
      "179": {
        start: {
          line: 393,
          column: 12
        },
        end: {
          line: 393,
          column: 29
        }
      },
      "180": {
        start: {
          line: 395,
          column: 10
        },
        end: {
          line: 395,
          column: 37
        }
      },
      "181": {
        start: {
          line: 399,
          column: 33
        },
        end: {
          line: 399,
          column: 64
        }
      },
      "182": {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 403,
          column: 5
        }
      },
      "183": {
        start: {
          line: 402,
          column: 6
        },
        end: {
          line: 402,
          column: 35
        }
      },
      "184": {
        start: {
          line: 405,
          column: 4
        },
        end: {
          line: 405,
          column: 23
        }
      },
      "185": {
        start: {
          line: 409,
          column: 4
        },
        end: {
          line: 409,
          column: 46
        }
      },
      "186": {
        start: {
          line: 413,
          column: 4
        },
        end: {
          line: 413,
          column: 27
        }
      },
      "187": {
        start: {
          line: 414,
          column: 4
        },
        end: {
          line: 416,
          column: 6
        }
      },
      "188": {
        start: {
          line: 415,
          column: 6
        },
        end: {
          line: 415,
          column: 48
        }
      },
      "189": {
        start: {
          line: 420,
          column: 37
        },
        end: {
          line: 420,
          column: 47
        }
      },
      "190": {
        start: {
          line: 422,
          column: 18
        },
        end: {
          line: 422,
          column: 32
        }
      },
      "191": {
        start: {
          line: 423,
          column: 4
        },
        end: {
          line: 423,
          column: 45
        }
      },
      "192": {
        start: {
          line: 423,
          column: 17
        },
        end: {
          line: 423,
          column: 45
        }
      },
      "193": {
        start: {
          line: 424,
          column: 4
        },
        end: {
          line: 424,
          column: 64
        }
      },
      "194": {
        start: {
          line: 424,
          column: 21
        },
        end: {
          line: 424,
          column: 64
        }
      },
      "195": {
        start: {
          line: 426,
          column: 4
        },
        end: {
          line: 432,
          column: 5
        }
      },
      "196": {
        start: {
          line: 428,
          column: 8
        },
        end: {
          line: 428,
          column: 36
        }
      },
      "197": {
        start: {
          line: 428,
          column: 30
        },
        end: {
          line: 428,
          column: 36
        }
      },
      "198": {
        start: {
          line: 429,
          column: 8
        },
        end: {
          line: 429,
          column: 38
        }
      },
      "199": {
        start: {
          line: 430,
          column: 8
        },
        end: {
          line: 430,
          column: 41
        }
      },
      "200": {
        start: {
          line: 445,
          column: 8
        },
        end: {
          line: 445,
          column: 18
        }
      },
      "201": {
        start: {
          line: 446,
          column: 18
        },
        end: {
          line: 446,
          column: 69
        }
      },
      "202": {
        start: {
          line: 447,
          column: 4
        },
        end: {
          line: 447,
          column: 48
        }
      },
      "203": {
        start: {
          line: 447,
          column: 37
        },
        end: {
          line: 447,
          column: 48
        }
      },
      "204": {
        start: {
          line: 449,
          column: 22
        },
        end: {
          line: 455,
          column: 5
        }
      },
      "205": {
        start: {
          line: 457,
          column: 4
        },
        end: {
          line: 476,
          column: 5
        }
      },
      "206": {
        start: {
          line: 497,
          column: 8
        },
        end: {
          line: 497,
          column: 18
        }
      },
      "207": {
        start: {
          line: 498,
          column: 31
        },
        end: {
          line: 498,
          column: 41
        }
      },
      "208": {
        start: {
          line: 499,
          column: 21
        },
        end: {
          line: 499,
          column: 40
        }
      },
      "209": {
        start: {
          line: 501,
          column: 22
        },
        end: {
          line: 510,
          column: 5
        }
      },
      "210": {
        start: {
          line: 511,
          column: 26
        },
        end: {
          line: 511,
          column: 62
        }
      },
      "211": {
        start: {
          line: 512,
          column: 28
        },
        end: {
          line: 512,
          column: 61
        }
      },
      "212": {
        start: {
          line: 514,
          column: 4
        },
        end: {
          line: 521,
          column: 5
        }
      },
      "213": {
        start: {
          line: 515,
          column: 6
        },
        end: {
          line: 520,
          column: 7
        }
      },
      "214": {
        start: {
          line: 523,
          column: 20
        },
        end: {
          line: 523,
          column: 53
        }
      },
      "215": {
        start: {
          line: 525,
          column: 4
        },
        end: {
          line: 579,
          column: 5
        }
      },
      "216": {
        start: {
          line: 532,
          column: 14
        },
        end: {
          line: 552,
          column: 21
        }
      },
      "217": {
        start: {
          line: 557,
          column: 14
        },
        end: {
          line: 557,
          column: 109
        }
      },
      "218": {
        start: {
          line: 564,
          column: 14
        },
        end: {
          line: 575,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 24
          },
          end: {
            line: 26,
            column: 25
          }
        },
        loc: {
          start: {
            line: 26,
            column: 40
          },
          end: {
            line: 26,
            column: 49
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 12
          }
        },
        loc: {
          start: {
            line: 29,
            column: 27
          },
          end: {
            line: 32,
            column: 5
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 34,
            column: 35
          },
          end: {
            line: 34,
            column: 36
          }
        },
        loc: {
          start: {
            line: 34,
            column: 51
          },
          end: {
            line: 34,
            column: 55
          }
        },
        line: 34
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 17
          },
          end: {
            line: 37,
            column: 18
          }
        },
        loc: {
          start: {
            line: 37,
            column: 53
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 40,
            column: 21
          },
          end: {
            line: 40,
            column: 22
          }
        },
        loc: {
          start: {
            line: 40,
            column: 42
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 40
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 51
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 71
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 93,
            column: 2
          },
          end: {
            line: 93,
            column: 3
          }
        },
        loc: {
          start: {
            line: 93,
            column: 47
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 93
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 24
          },
          end: {
            line: 106,
            column: 3
          }
        },
        line: 101
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 44
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 108
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 118,
            column: 3
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 120,
            column: 2
          },
          end: {
            line: 120,
            column: 3
          }
        },
        loc: {
          start: {
            line: 120,
            column: 19
          },
          end: {
            line: 124,
            column: 3
          }
        },
        line: 120
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 126,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        loc: {
          start: {
            line: 126,
            column: 13
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 126
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 128,
            column: 23
          },
          end: {
            line: 128,
            column: 24
          }
        },
        loc: {
          start: {
            line: 128,
            column: 44
          },
          end: {
            line: 131,
            column: 5
          }
        },
        line: 128
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        loc: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 153,
            column: 3
          }
        },
        line: 134
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 143,
            column: 14
          },
          end: {
            line: 143,
            column: 15
          }
        },
        loc: {
          start: {
            line: 143,
            column: 23
          },
          end: {
            line: 145,
            column: 9
          }
        },
        line: 143
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 9
          }
        },
        loc: {
          start: {
            line: 146,
            column: 14
          },
          end: {
            line: 150,
            column: 9
          }
        },
        line: 146
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 155,
            column: 2
          },
          end: {
            line: 155,
            column: 3
          }
        },
        loc: {
          start: {
            line: 155,
            column: 29
          },
          end: {
            line: 176,
            column: 3
          }
        },
        line: 155
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 161,
            column: 13
          }
        },
        loc: {
          start: {
            line: 161,
            column: 18
          },
          end: {
            line: 174,
            column: 7
          }
        },
        line: 161
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 163,
            column: 16
          },
          end: {
            line: 163,
            column: 17
          }
        },
        loc: {
          start: {
            line: 163,
            column: 25
          },
          end: {
            line: 168,
            column: 11
          }
        },
        line: 163
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 170,
            column: 46
          },
          end: {
            line: 170,
            column: 47
          }
        },
        loc: {
          start: {
            line: 170,
            column: 55
          },
          end: {
            line: 172,
            column: 9
          }
        },
        line: 170
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 175,
            column: 13
          },
          end: {
            line: 175,
            column: 14
          }
        },
        loc: {
          start: {
            line: 175,
            column: 19
          },
          end: {
            line: 175,
            column: 21
          }
        },
        line: 175
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 178,
            column: 2
          },
          end: {
            line: 178,
            column: 3
          }
        },
        loc: {
          start: {
            line: 178,
            column: 48
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 178
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 182,
            column: 30
          },
          end: {
            line: 182,
            column: 31
          }
        },
        loc: {
          start: {
            line: 182,
            column: 54
          },
          end: {
            line: 184,
            column: 7
          }
        },
        line: 182
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 187,
            column: 12
          },
          end: {
            line: 187,
            column: 13
          }
        },
        loc: {
          start: {
            line: 187,
            column: 21
          },
          end: {
            line: 189,
            column: 7
          }
        },
        line: 187
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 193,
            column: 2
          },
          end: {
            line: 193,
            column: 3
          }
        },
        loc: {
          start: {
            line: 193,
            column: 33
          },
          end: {
            line: 219,
            column: 3
          }
        },
        line: 193
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 221,
            column: 2
          },
          end: {
            line: 221,
            column: 3
          }
        },
        loc: {
          start: {
            line: 221,
            column: 90
          },
          end: {
            line: 305,
            column: 3
          }
        },
        line: 221
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 256,
            column: 18
          },
          end: {
            line: 256,
            column: 19
          }
        },
        loc: {
          start: {
            line: 256,
            column: 26
          },
          end: {
            line: 266,
            column: 13
          }
        },
        line: 256
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 259,
            column: 24
          },
          end: {
            line: 259,
            column: 25
          }
        },
        loc: {
          start: {
            line: 259,
            column: 33
          },
          end: {
            line: 261,
            column: 19
          }
        },
        line: 259
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 267,
            column: 19
          },
          end: {
            line: 267,
            column: 20
          }
        },
        loc: {
          start: {
            line: 267,
            column: 25
          },
          end: {
            line: 267,
            column: 29
          }
        },
        line: 267
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 275,
            column: 16
          },
          end: {
            line: 275,
            column: 17
          }
        },
        loc: {
          start: {
            line: 275,
            column: 24
          },
          end: {
            line: 286,
            column: 11
          }
        },
        line: 275
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 279,
            column: 22
          },
          end: {
            line: 279,
            column: 23
          }
        },
        loc: {
          start: {
            line: 279,
            column: 31
          },
          end: {
            line: 281,
            column: 17
          }
        },
        line: 279
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 288,
            column: 17
          },
          end: {
            line: 288,
            column: 18
          }
        },
        loc: {
          start: {
            line: 288,
            column: 23
          },
          end: {
            line: 298,
            column: 11
          }
        },
        line: 288
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 291,
            column: 22
          },
          end: {
            line: 291,
            column: 23
          }
        },
        loc: {
          start: {
            line: 291,
            column: 31
          },
          end: {
            line: 293,
            column: 17
          }
        },
        line: 291
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 307,
            column: 2
          },
          end: {
            line: 307,
            column: 3
          }
        },
        loc: {
          start: {
            line: 307,
            column: 49
          },
          end: {
            line: 406,
            column: 3
          }
        },
        line: 307
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 337,
            column: 18
          },
          end: {
            line: 337,
            column: 19
          }
        },
        loc: {
          start: {
            line: 337,
            column: 104
          },
          end: {
            line: 359,
            column: 7
          }
        },
        line: 337
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 341,
            column: 19
          },
          end: {
            line: 341,
            column: 20
          }
        },
        loc: {
          start: {
            line: 341,
            column: 25
          },
          end: {
            line: 343,
            column: 9
          }
        },
        line: 341
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 347,
            column: 18
          },
          end: {
            line: 347,
            column: 19
          }
        },
        loc: {
          start: {
            line: 347,
            column: 27
          },
          end: {
            line: 350,
            column: 13
          }
        },
        line: 347
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 352,
            column: 12
          },
          end: {
            line: 352,
            column: 13
          }
        },
        loc: {
          start: {
            line: 352,
            column: 18
          },
          end: {
            line: 356,
            column: 13
          }
        },
        line: 352
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 363,
            column: 14
          },
          end: {
            line: 363,
            column: 15
          }
        },
        loc: {
          start: {
            line: 363,
            column: 39
          },
          end: {
            line: 397,
            column: 7
          }
        },
        line: 363
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 379,
            column: 18
          },
          end: {
            line: 379,
            column: 19
          }
        },
        loc: {
          start: {
            line: 379,
            column: 27
          },
          end: {
            line: 383,
            column: 13
          }
        },
        line: 379
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 387,
            column: 18
          },
          end: {
            line: 387,
            column: 19
          }
        },
        loc: {
          start: {
            line: 387,
            column: 27
          },
          end: {
            line: 389,
            column: 13
          }
        },
        line: 387
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 392,
            column: 49
          },
          end: {
            line: 392,
            column: 50
          }
        },
        loc: {
          start: {
            line: 392,
            column: 58
          },
          end: {
            line: 394,
            column: 11
          }
        },
        line: 392
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 399,
            column: 15
          },
          end: {
            line: 399,
            column: 16
          }
        },
        loc: {
          start: {
            line: 399,
            column: 33
          },
          end: {
            line: 399,
            column: 64
          }
        },
        line: 399
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 402,
            column: 27
          },
          end: {
            line: 402,
            column: 28
          }
        },
        loc: {
          start: {
            line: 402,
            column: 33
          },
          end: {
            line: 402,
            column: 35
          }
        },
        line: 402
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 408,
            column: 2
          },
          end: {
            line: 408,
            column: 3
          }
        },
        loc: {
          start: {
            line: 408,
            column: 32
          },
          end: {
            line: 410,
            column: 3
          }
        },
        line: 408
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 412,
            column: 2
          },
          end: {
            line: 412,
            column: 3
          }
        },
        loc: {
          start: {
            line: 412,
            column: 46
          },
          end: {
            line: 417,
            column: 3
          }
        },
        line: 412
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 414,
            column: 15
          },
          end: {
            line: 414,
            column: 16
          }
        },
        loc: {
          start: {
            line: 414,
            column: 21
          },
          end: {
            line: 416,
            column: 5
          }
        },
        line: 414
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 419,
            column: 2
          },
          end: {
            line: 419,
            column: 3
          }
        },
        loc: {
          start: {
            line: 419,
            column: 52
          },
          end: {
            line: 433,
            column: 3
          }
        },
        line: 419
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 427,
            column: 12
          },
          end: {
            line: 427,
            column: 13
          }
        },
        loc: {
          start: {
            line: 427,
            column: 21
          },
          end: {
            line: 431,
            column: 7
          }
        },
        line: 427
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 435,
            column: 2
          },
          end: {
            line: 435,
            column: 3
          }
        },
        loc: {
          start: {
            line: 435,
            column: 17
          },
          end: {
            line: 477,
            column: 3
          }
        },
        line: 435
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 479,
            column: 2
          },
          end: {
            line: 479,
            column: 3
          }
        },
        loc: {
          start: {
            line: 479,
            column: 11
          },
          end: {
            line: 580,
            column: 3
          }
        },
        line: 479
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 531,
            column: 22
          },
          end: {
            line: 531,
            column: 23
          }
        },
        loc: {
          start: {
            line: 532,
            column: 14
          },
          end: {
            line: 552,
            column: 21
          }
        },
        line: 532
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 556,
            column: 35
          },
          end: {
            line: 556,
            column: 36
          }
        },
        loc: {
          start: {
            line: 557,
            column: 14
          },
          end: {
            line: 557,
            column: 109
          }
        },
        line: 557
      },
      "53": {
        name: "(anonymous_53)",
        decl: {
          start: {
            line: 563,
            column: 24
          },
          end: {
            line: 563,
            column: 25
          }
        },
        loc: {
          start: {
            line: 564,
            column: 14
          },
          end: {
            line: 575,
            column: 16
          }
        },
        line: 564
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 55
          }
        }, {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 55
          }
        }],
        line: 39
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 9
          }
        }, {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 39,
            column: 43
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 41
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 41
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }],
        line: 95
      },
      "4": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 49
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 49
          }
        }],
        line: 103
      },
      "5": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 57
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 104,
            column: 57
          }
        }],
        line: 104
      },
      "6": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 58
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 58
          }
        }],
        line: 111
      },
      "7": {
        loc: {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 24
          }
        }, {
          start: {
            line: 122,
            column: 4
          },
          end: {
            line: 122,
            column: 24
          }
        }],
        line: 122
      },
      "8": {
        loc: {
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 66
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 66
          }
        }, {
          start: {
            line: 129,
            column: 6
          },
          end: {
            line: 129,
            column: 66
          }
        }],
        line: 129
      },
      "9": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 64
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 138,
            column: 64
          }
        }],
        line: 138
      },
      "10": {
        loc: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 20
          }
        }, {
          start: {
            line: 138,
            column: 24
          },
          end: {
            line: 138,
            column: 44
          }
        }],
        line: 138
      },
      "11": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 152,
            column: 5
          }
        }],
        line: 140
      },
      "12": {
        loc: {
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 141,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 141,
            column: 54
          }
        }, {
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 141,
            column: 54
          }
        }],
        line: 141
      },
      "13": {
        loc: {
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 141,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 10
          },
          end: {
            line: 141,
            column: 18
          }
        }, {
          start: {
            line: 141,
            column: 22
          },
          end: {
            line: 141,
            column: 36
          }
        }],
        line: 141
      },
      "14": {
        loc: {
          start: {
            line: 147,
            column: 10
          },
          end: {
            line: 149,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 10
          },
          end: {
            line: 149,
            column: 11
          }
        }, {
          start: {
            line: 147,
            column: 10
          },
          end: {
            line: 149,
            column: 11
          }
        }],
        line: 147
      },
      "15": {
        loc: {
          start: {
            line: 147,
            column: 14
          },
          end: {
            line: 147,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 14
          },
          end: {
            line: 147,
            column: 35
          }
        }, {
          start: {
            line: 147,
            column: 39
          },
          end: {
            line: 147,
            column: 52
          }
        }],
        line: 147
      },
      "16": {
        loc: {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 24
          }
        }, {
          start: {
            line: 157,
            column: 4
          },
          end: {
            line: 157,
            column: 24
          }
        }],
        line: 157
      },
      "17": {
        loc: {
          start: {
            line: 159,
            column: 24
          },
          end: {
            line: 159,
            column: 102
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 159,
            column: 61
          },
          end: {
            line: 159,
            column: 82
          }
        }, {
          start: {
            line: 159,
            column: 85
          },
          end: {
            line: 159,
            column: 102
          }
        }],
        line: 159
      },
      "18": {
        loc: {
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        }, {
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        }],
        line: 165
      },
      "19": {
        loc: {
          start: {
            line: 165,
            column: 16
          },
          end: {
            line: 165,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 165,
            column: 16
          },
          end: {
            line: 165,
            column: 47
          }
        }, {
          start: {
            line: 165,
            column: 51
          },
          end: {
            line: 165,
            column: 85
          }
        }],
        line: 165
      },
      "20": {
        loc: {
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 24
          }
        }, {
          start: {
            line: 180,
            column: 4
          },
          end: {
            line: 180,
            column: 24
          }
        }],
        line: 180
      },
      "21": {
        loc: {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }, {
          start: {
            line: 199,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }],
        line: 199
      },
      "22": {
        loc: {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 201,
            column: 89
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 201,
            column: 89
          }
        }, {
          start: {
            line: 201,
            column: 6
          },
          end: {
            line: 201,
            column: 89
          }
        }],
        line: 201
      },
      "23": {
        loc: {
          start: {
            line: 201,
            column: 39
          },
          end: {
            line: 201,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 201,
            column: 39
          },
          end: {
            line: 201,
            column: 58
          }
        }, {
          start: {
            line: 201,
            column: 62
          },
          end: {
            line: 201,
            column: 88
          }
        }],
        line: 201
      },
      "24": {
        loc: {
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }, {
          start: {
            line: 206,
            column: 6
          },
          end: {
            line: 214,
            column: 7
          }
        }],
        line: 206
      },
      "25": {
        loc: {
          start: {
            line: 206,
            column: 10
          },
          end: {
            line: 206,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 10
          },
          end: {
            line: 206,
            column: 19
          }
        }, {
          start: {
            line: 206,
            column: 23
          },
          end: {
            line: 206,
            column: 64
          }
        }],
        line: 206
      },
      "26": {
        loc: {
          start: {
            line: 211,
            column: 18
          },
          end: {
            line: 211,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 211,
            column: 41
          },
          end: {
            line: 211,
            column: 44
          }
        }, {
          start: {
            line: 211,
            column: 47
          },
          end: {
            line: 211,
            column: 61
          }
        }],
        line: 211
      },
      "27": {
        loc: {
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 213,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 213,
            column: 48
          }
        }, {
          start: {
            line: 213,
            column: 8
          },
          end: {
            line: 213,
            column: 48
          }
        }],
        line: 213
      },
      "28": {
        loc: {
          start: {
            line: 222,
            column: 33
          },
          end: {
            line: 222,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 222,
            column: 41
          },
          end: {
            line: 222,
            column: 59
          }
        }],
        line: 222
      },
      "29": {
        loc: {
          start: {
            line: 226,
            column: 19
          },
          end: {
            line: 226,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 83
          }
        }, {
          start: {
            line: 226,
            column: 88
          },
          end: {
            line: 226,
            column: 90
          }
        }],
        line: 226
      },
      "30": {
        loc: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 226,
            column: 47
          },
          end: {
            line: 226,
            column: 54
          }
        }, {
          start: {
            line: 226,
            column: 57
          },
          end: {
            line: 226,
            column: 83
          }
        }],
        line: 226
      },
      "31": {
        loc: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 226,
            column: 33
          }
        }, {
          start: {
            line: 226,
            column: 37
          },
          end: {
            line: 226,
            column: 44
          }
        }],
        line: 226
      },
      "32": {
        loc: {
          start: {
            line: 226,
            column: 57
          },
          end: {
            line: 226,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 57
          },
          end: {
            line: 226,
            column: 65
          }
        }, {
          start: {
            line: 226,
            column: 69
          },
          end: {
            line: 226,
            column: 83
          }
        }],
        line: 226
      },
      "33": {
        loc: {
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 71
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 71
          }
        }, {
          start: {
            line: 227,
            column: 4
          },
          end: {
            line: 227,
            column: 71
          }
        }],
        line: 227
      },
      "34": {
        loc: {
          start: {
            line: 227,
            column: 32
          },
          end: {
            line: 227,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 32
          },
          end: {
            line: 227,
            column: 65
          }
        }, {
          start: {
            line: 227,
            column: 69
          },
          end: {
            line: 227,
            column: 71
          }
        }],
        line: 227
      },
      "35": {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 30
          }
        }, {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 30
          }
        }],
        line: 229
      },
      "36": {
        loc: {
          start: {
            line: 244,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 244,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        }, {
          start: {
            line: 244,
            column: 6
          },
          end: {
            line: 270,
            column: 7
          }
        }],
        line: 244
      },
      "37": {
        loc: {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 248,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 248,
            column: 9
          }
        }, {
          start: {
            line: 245,
            column: 8
          },
          end: {
            line: 248,
            column: 9
          }
        }],
        line: 245
      },
      "38": {
        loc: {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        }, {
          start: {
            line: 253,
            column: 8
          },
          end: {
            line: 268,
            column: 9
          }
        }],
        line: 253
      },
      "39": {
        loc: {
          start: {
            line: 257,
            column: 14
          },
          end: {
            line: 265,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 257,
            column: 14
          },
          end: {
            line: 265,
            column: 15
          }
        }, {
          start: {
            line: 257,
            column: 14
          },
          end: {
            line: 265,
            column: 15
          }
        }],
        line: 257
      },
      "40": {
        loc: {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        }, {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 301,
            column: 7
          }
        }],
        line: 272
      },
      "41": {
        loc: {
          start: {
            line: 276,
            column: 12
          },
          end: {
            line: 276,
            column: 91
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 276,
            column: 12
          },
          end: {
            line: 276,
            column: 91
          }
        }, {
          start: {
            line: 276,
            column: 12
          },
          end: {
            line: 276,
            column: 91
          }
        }],
        line: 276
      },
      "42": {
        loc: {
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 285,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 285,
            column: 13
          }
        }, {
          start: {
            line: 277,
            column: 12
          },
          end: {
            line: 285,
            column: 13
          }
        }],
        line: 277
      },
      "43": {
        loc: {
          start: {
            line: 289,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 289,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }, {
          start: {
            line: 289,
            column: 12
          },
          end: {
            line: 297,
            column: 13
          }
        }],
        line: 289
      },
      "44": {
        loc: {
          start: {
            line: 322,
            column: 16
          },
          end: {
            line: 322,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 322,
            column: 16
          },
          end: {
            line: 322,
            column: 23
          }
        }, {
          start: {
            line: 322,
            column: 27
          },
          end: {
            line: 322,
            column: 41
          }
        }],
        line: 322
      },
      "45": {
        loc: {
          start: {
            line: 327,
            column: 13
          },
          end: {
            line: 327,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 327,
            column: 13
          },
          end: {
            line: 327,
            column: 21
          }
        }, {
          start: {
            line: 327,
            column: 25
          },
          end: {
            line: 327,
            column: 29
          }
        }],
        line: 327
      },
      "46": {
        loc: {
          start: {
            line: 338,
            column: 24
          },
          end: {
            line: 338,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 338,
            column: 56
          },
          end: {
            line: 338,
            column: 65
          }
        }, {
          start: {
            line: 338,
            column: 68
          },
          end: {
            line: 338,
            column: 94
          }
        }],
        line: 338
      },
      "47": {
        loc: {
          start: {
            line: 339,
            column: 8
          },
          end: {
            line: 339,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 339,
            column: 8
          },
          end: {
            line: 339,
            column: 28
          }
        }, {
          start: {
            line: 339,
            column: 8
          },
          end: {
            line: 339,
            column: 28
          }
        }],
        line: 339
      },
      "48": {
        loc: {
          start: {
            line: 345,
            column: 8
          },
          end: {
            line: 358,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 345,
            column: 8
          },
          end: {
            line: 358,
            column: 9
          }
        }, {
          start: {
            line: 345,
            column: 8
          },
          end: {
            line: 358,
            column: 9
          }
        }],
        line: 345
      },
      "49": {
        loc: {
          start: {
            line: 349,
            column: 14
          },
          end: {
            line: 349,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 349,
            column: 14
          },
          end: {
            line: 349,
            column: 52
          }
        }, {
          start: {
            line: 349,
            column: 14
          },
          end: {
            line: 349,
            column: 52
          }
        }],
        line: 349
      },
      "50": {
        loc: {
          start: {
            line: 353,
            column: 14
          },
          end: {
            line: 355,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 353,
            column: 14
          },
          end: {
            line: 355,
            column: 15
          }
        }, {
          start: {
            line: 353,
            column: 14
          },
          end: {
            line: 355,
            column: 15
          }
        }],
        line: 353
      },
      "51": {
        loc: {
          start: {
            line: 364,
            column: 8
          },
          end: {
            line: 367,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 364,
            column: 8
          },
          end: {
            line: 367,
            column: 9
          }
        }, {
          start: {
            line: 364,
            column: 8
          },
          end: {
            line: 367,
            column: 9
          }
        }],
        line: 364
      },
      "52": {
        loc: {
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 370,
            column: 86
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 370,
            column: 86
          }
        }, {
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 370,
            column: 86
          }
        }],
        line: 370
      },
      "53": {
        loc: {
          start: {
            line: 370,
            column: 12
          },
          end: {
            line: 370,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 370,
            column: 12
          },
          end: {
            line: 370,
            column: 39
          }
        }, {
          start: {
            line: 370,
            column: 43
          },
          end: {
            line: 370,
            column: 60
          }
        }],
        line: 370
      },
      "54": {
        loc: {
          start: {
            line: 371,
            column: 8
          },
          end: {
            line: 371,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 371,
            column: 8
          },
          end: {
            line: 371,
            column: 40
          }
        }, {
          start: {
            line: 371,
            column: 8
          },
          end: {
            line: 371,
            column: 40
          }
        }],
        line: 371
      },
      "55": {
        loc: {
          start: {
            line: 373,
            column: 8
          },
          end: {
            line: 375,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 373,
            column: 8
          },
          end: {
            line: 375,
            column: 9
          }
        }, {
          start: {
            line: 373,
            column: 8
          },
          end: {
            line: 375,
            column: 9
          }
        }],
        line: 373
      },
      "56": {
        loc: {
          start: {
            line: 377,
            column: 8
          },
          end: {
            line: 396,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 377,
            column: 8
          },
          end: {
            line: 396,
            column: 9
          }
        }, {
          start: {
            line: 377,
            column: 8
          },
          end: {
            line: 396,
            column: 9
          }
        }],
        line: 377
      },
      "57": {
        loc: {
          start: {
            line: 401,
            column: 4
          },
          end: {
            line: 403,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 401,
            column: 4
          },
          end: {
            line: 403,
            column: 5
          }
        }, {
          start: {
            line: 401,
            column: 4
          },
          end: {
            line: 403,
            column: 5
          }
        }],
        line: 401
      },
      "58": {
        loc: {
          start: {
            line: 401,
            column: 8
          },
          end: {
            line: 401,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 401,
            column: 8
          },
          end: {
            line: 401,
            column: 28
          }
        }, {
          start: {
            line: 401,
            column: 32
          },
          end: {
            line: 401,
            column: 51
          }
        }],
        line: 401
      },
      "59": {
        loc: {
          start: {
            line: 423,
            column: 4
          },
          end: {
            line: 423,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 423,
            column: 4
          },
          end: {
            line: 423,
            column: 45
          }
        }, {
          start: {
            line: 423,
            column: 4
          },
          end: {
            line: 423,
            column: 45
          }
        }],
        line: 423
      },
      "60": {
        loc: {
          start: {
            line: 424,
            column: 4
          },
          end: {
            line: 424,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 424,
            column: 4
          },
          end: {
            line: 424,
            column: 64
          }
        }, {
          start: {
            line: 424,
            column: 4
          },
          end: {
            line: 424,
            column: 64
          }
        }],
        line: 424
      },
      "61": {
        loc: {
          start: {
            line: 424,
            column: 31
          },
          end: {
            line: 424,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 424,
            column: 31
          },
          end: {
            line: 424,
            column: 53
          }
        }, {
          start: {
            line: 424,
            column: 57
          },
          end: {
            line: 424,
            column: 64
          }
        }],
        line: 424
      },
      "62": {
        loc: {
          start: {
            line: 428,
            column: 8
          },
          end: {
            line: 428,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 428,
            column: 8
          },
          end: {
            line: 428,
            column: 36
          }
        }, {
          start: {
            line: 428,
            column: 8
          },
          end: {
            line: 428,
            column: 36
          }
        }],
        line: 428
      },
      "63": {
        loc: {
          start: {
            line: 437,
            column: 6
          },
          end: {
            line: 437,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 437,
            column: 14
          },
          end: {
            line: 437,
            column: 32
          }
        }],
        line: 437
      },
      "64": {
        loc: {
          start: {
            line: 447,
            column: 4
          },
          end: {
            line: 447,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 447,
            column: 4
          },
          end: {
            line: 447,
            column: 48
          }
        }, {
          start: {
            line: 447,
            column: 4
          },
          end: {
            line: 447,
            column: 48
          }
        }],
        line: 447
      },
      "65": {
        loc: {
          start: {
            line: 447,
            column: 8
          },
          end: {
            line: 447,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 447,
            column: 8
          },
          end: {
            line: 447,
            column: 17
          }
        }, {
          start: {
            line: 447,
            column: 21
          },
          end: {
            line: 447,
            column: 35
          }
        }],
        line: 447
      },
      "66": {
        loc: {
          start: {
            line: 463,
            column: 18
          },
          end: {
            line: 463,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 463,
            column: 18
          },
          end: {
            line: 463,
            column: 28
          }
        }, {
          start: {
            line: 463,
            column: 32
          },
          end: {
            line: 463,
            column: 41
          }
        }],
        line: 463
      },
      "67": {
        loc: {
          start: {
            line: 465,
            column: 47
          },
          end: {
            line: 465,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 465,
            column: 47
          },
          end: {
            line: 465,
            column: 55
          }
        }, {
          start: {
            line: 465,
            column: 59
          },
          end: {
            line: 465,
            column: 69
          }
        }],
        line: 465
      },
      "68": {
        loc: {
          start: {
            line: 481,
            column: 6
          },
          end: {
            line: 481,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 481,
            column: 14
          },
          end: {
            line: 481,
            column: 32
          }
        }],
        line: 481
      },
      "69": {
        loc: {
          start: {
            line: 499,
            column: 21
          },
          end: {
            line: 499,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 499,
            column: 21
          },
          end: {
            line: 499,
            column: 25
          }
        }, {
          start: {
            line: 499,
            column: 29
          },
          end: {
            line: 499,
            column: 40
          }
        }],
        line: 499
      },
      "70": {
        loc: {
          start: {
            line: 504,
            column: 8
          },
          end: {
            line: 504,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 504,
            column: 8
          },
          end: {
            line: 504,
            column: 15
          }
        }, {
          start: {
            line: 504,
            column: 19
          },
          end: {
            line: 504,
            column: 24
          }
        }],
        line: 504
      },
      "71": {
        loc: {
          start: {
            line: 505,
            column: 8
          },
          end: {
            line: 505,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 505,
            column: 8
          },
          end: {
            line: 505,
            column: 16
          }
        }, {
          start: {
            line: 505,
            column: 20
          },
          end: {
            line: 505,
            column: 30
          }
        }],
        line: 505
      },
      "72": {
        loc: {
          start: {
            line: 506,
            column: 8
          },
          end: {
            line: 506,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 506,
            column: 8
          },
          end: {
            line: 506,
            column: 32
          }
        }, {
          start: {
            line: 506,
            column: 36
          },
          end: {
            line: 506,
            column: 47
          }
        }],
        line: 506
      },
      "73": {
        loc: {
          start: {
            line: 507,
            column: 8
          },
          end: {
            line: 507,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 507,
            column: 8
          },
          end: {
            line: 507,
            column: 16
          }
        }, {
          start: {
            line: 507,
            column: 20
          },
          end: {
            line: 507,
            column: 31
          }
        }],
        line: 507
      },
      "74": {
        loc: {
          start: {
            line: 511,
            column: 26
          },
          end: {
            line: 511,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 511,
            column: 39
          },
          end: {
            line: 511,
            column: 48
          }
        }, {
          start: {
            line: 511,
            column: 51
          },
          end: {
            line: 511,
            column: 62
          }
        }],
        line: 511
      },
      "75": {
        loc: {
          start: {
            line: 512,
            column: 28
          },
          end: {
            line: 512,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 512,
            column: 41
          },
          end: {
            line: 512,
            column: 52
          }
        }, {
          start: {
            line: 512,
            column: 55
          },
          end: {
            line: 512,
            column: 61
          }
        }],
        line: 512
      },
      "76": {
        loc: {
          start: {
            line: 514,
            column: 4
          },
          end: {
            line: 521,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 514,
            column: 4
          },
          end: {
            line: 521,
            column: 5
          }
        }, {
          start: {
            line: 514,
            column: 4
          },
          end: {
            line: 521,
            column: 5
          }
        }],
        line: 514
      },
      "77": {
        loc: {
          start: {
            line: 523,
            column: 20
          },
          end: {
            line: 523,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 523,
            column: 33
          },
          end: {
            line: 523,
            column: 36
          }
        }, {
          start: {
            line: 523,
            column: 39
          },
          end: {
            line: 523,
            column: 53
          }
        }],
        line: 523
      },
      "78": {
        loc: {
          start: {
            line: 527,
            column: 22
          },
          end: {
            line: 527,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 527,
            column: 35
          },
          end: {
            line: 527,
            column: 43
          }
        }, {
          start: {
            line: 527,
            column: 46
          },
          end: {
            line: 527,
            column: 50
          }
        }],
        line: 527
      },
      "79": {
        loc: {
          start: {
            line: 528,
            column: 11
          },
          end: {
            line: 528,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 528,
            column: 11
          },
          end: {
            line: 528,
            column: 22
          }
        }, {
          start: {
            line: 528,
            column: 26
          },
          end: {
            line: 528,
            column: 45
          }
        }],
        line: 528
      },
      "80": {
        loc: {
          start: {
            line: 529,
            column: 11
          },
          end: {
            line: 529,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 529,
            column: 11
          },
          end: {
            line: 529,
            column: 21
          }
        }, {
          start: {
            line: 529,
            column: 25
          },
          end: {
            line: 529,
            column: 36
          }
        }, {
          start: {
            line: 529,
            column: 40
          },
          end: {
            line: 529,
            column: 59
          }
        }],
        line: 529
      },
      "81": {
        loc: {
          start: {
            line: 530,
            column: 11
          },
          end: {
            line: 553,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 530,
            column: 11
          },
          end: {
            line: 530,
            column: 25
          }
        }, {
          start: {
            line: 531,
            column: 12
          },
          end: {
            line: 553,
            column: 14
          }
        }],
        line: 530
      },
      "82": {
        loc: {
          start: {
            line: 548,
            column: 28
          },
          end: {
            line: 548,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 548,
            column: 54
          },
          end: {
            line: 548,
            column: 70
          }
        }, {
          start: {
            line: 548,
            column: 73
          },
          end: {
            line: 548,
            column: 82
          }
        }],
        line: 548
      },
      "83": {
        loc: {
          start: {
            line: 555,
            column: 11
          },
          end: {
            line: 558,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 555,
            column: 11
          },
          end: {
            line: 555,
            column: 25
          }
        }, {
          start: {
            line: 556,
            column: 12
          },
          end: {
            line: 558,
            column: 14
          }
        }],
        line: 555
      },
      "84": {
        loc: {
          start: {
            line: 560,
            column: 11
          },
          end: {
            line: 560,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 560,
            column: 11
          },
          end: {
            line: 560,
            column: 21
          }
        }, {
          start: {
            line: 560,
            column: 25
          },
          end: {
            line: 560,
            column: 37
          }
        }, {
          start: {
            line: 560,
            column: 41
          },
          end: {
            line: 560,
            column: 60
          }
        }],
        line: 560
      },
      "85": {
        loc: {
          start: {
            line: 562,
            column: 11
          },
          end: {
            line: 576,
            column: 14
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 562,
            column: 11
          },
          end: {
            line: 562,
            column: 22
          }
        }, {
          start: {
            line: 563,
            column: 12
          },
          end: {
            line: 576,
            column: 14
          }
        }],
        line: 562
      },
      "86": {
        loc: {
          start: {
            line: 572,
            column: 29
          },
          end: {
            line: 572,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 572,
            column: 29
          },
          end: {
            line: 572,
            column: 40
          }
        }, {
          start: {
            line: 572,
            column: 44
          },
          end: {
            line: 572,
            column: 64
          }
        }],
        line: 572
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0],
      "69": [0, 0],
      "70": [0, 0],
      "71": [0, 0],
      "72": [0, 0],
      "73": [0, 0],
      "74": [0, 0],
      "75": [0, 0],
      "76": [0, 0],
      "77": [0, 0],
      "78": [0, 0],
      "79": [0, 0],
      "80": [0, 0, 0],
      "81": [0, 0],
      "82": [0, 0],
      "83": [0, 0],
      "84": [0, 0, 0],
      "85": [0, 0],
      "86": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _regeneratorRuntime from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/Upload.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import immer from 'immer';
import Gap from '../Gap';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { FormError } from '../utils/errors';
import { uploadClass } from './styles';
import defaultRequest, { ERROR, UPLOADING } from './request';
import FileInput from './FileInput';
import FileContent from './File';
import ImageFile from './ImageFile';
import Result from './Result';
import ImageResult from './ImageResult';
import { Provider } from './context';
import Drop from './Drop';
import attrAccept from '../utils/accept';
import { isFunc } from '../utils/is';
import { getLocale } from '../locale';
import acceptHOC from './accept';
import getDataset from '../utils/dom/getDataset';
import { isRTL } from '../config';
var VALIDATORITEMS = (cov_209l5tj3cs.s[0]++, [{
  key: 'size',
  param: function param(blob) {
    cov_209l5tj3cs.f[0]++;
    cov_209l5tj3cs.s[1]++;
    return blob.size;
  }
}, {
  key: 'ext',
  param: function param(blob) {
    cov_209l5tj3cs.f[1]++;
    var exts = (cov_209l5tj3cs.s[2]++, blob.name.split('.'));
    cov_209l5tj3cs.s[3]++;
    return exts[exts.length - 1];
  }
}, {
  key: 'customValidator',
  param: function param(blob) {
    cov_209l5tj3cs.f[2]++;
    cov_209l5tj3cs.s[4]++;
    return blob;
  }
}]);
cov_209l5tj3cs.s[5]++;

var promised = function promised(action) {
  cov_209l5tj3cs.f[3]++;

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var res = (cov_209l5tj3cs.s[6]++, action.apply(void 0, args));
  cov_209l5tj3cs.s[7]++;

  if ((cov_209l5tj3cs.b[1][0]++, res) && (cov_209l5tj3cs.b[1][1]++, typeof res.then === 'function')) {
    cov_209l5tj3cs.b[0][0]++;
    cov_209l5tj3cs.s[8]++;
    return res;
  } else {
    cov_209l5tj3cs.b[0][1]++;
  }

  cov_209l5tj3cs.s[9]++;
  return new Promise(function (resolve, reject) {
    cov_209l5tj3cs.f[4]++;
    cov_209l5tj3cs.s[10]++;

    if (res instanceof Error) {
      cov_209l5tj3cs.b[2][0]++;
      cov_209l5tj3cs.s[11]++;
      reject(res);
    } else {
      cov_209l5tj3cs.b[2][1]++;
    }

    cov_209l5tj3cs.s[12]++;
    resolve(true);
  });
};

var DefaultProps = (cov_209l5tj3cs.s[13]++, {
  cors: false,
  limit: 100,
  recoverAble: false,
  validator: {},
  value: [],
  withCredentials: false,
  showUploadList: true,
  validatorHandle: true,
  canDelete: true,
  GapProps: {
    column: 12,
    row: 12
  }
});

var Upload =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Upload, _PureComponent);

  var _super = _createSuper2(Upload);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    cov_209l5tj3cs.f[5]++;
    cov_209l5tj3cs.s[14]++;
    _this = _super.call(this, props);
    _this.input = void 0;
    cov_209l5tj3cs.s[15]++;
    _this.state = {
      files: {},
      recycle: []
    };
    cov_209l5tj3cs.s[16]++;
    _this.addFile = _this.addFile.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[17]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[18]++;
    _this.handleAddClick = _this.handleAddClick.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[19]++;
    _this.removeFile = _this.removeFile.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[20]++;
    _this.removeValue = _this.removeValue.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[21]++;
    _this.recoverValue = _this.recoverValue.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[22]++;
    _this.validatorHandle = _this.validatorHandle.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[23]++;
    _this.useValidator = _this.useValidator.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[24]++;
    _this.handleFileDrop = _this.handleFileDrop.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[25]++;
    _this.handleReplace = _this.handleReplace.bind(_assertThisInitialized(_this));
    cov_209l5tj3cs.s[26]++;
    props.validateHook(_this.validate.bind(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Upload, [{
    key: "getCanDelete",
    value: function getCanDelete(item, index) {
      cov_209l5tj3cs.f[6]++;

      var _ref = (cov_209l5tj3cs.s[27]++, this.props),
          canDelete = _ref.canDelete;

      cov_209l5tj3cs.s[28]++;

      if (isFunc(canDelete)) {
        cov_209l5tj3cs.b[3][0]++;
        cov_209l5tj3cs.s[29]++;
        return canDelete(item, index);
      } else {
        cov_209l5tj3cs.b[3][1]++;
      }

      cov_209l5tj3cs.s[30]++;
      return canDelete;
    }
  }, {
    key: "getAction",
    value: function getAction(file) {
      cov_209l5tj3cs.f[7]++;

      var _ref2 = (cov_209l5tj3cs.s[31]++, this.props),
          action = _ref2.action;

      cov_209l5tj3cs.s[32]++;

      if (typeof action === 'string') {
        cov_209l5tj3cs.b[4][0]++;
        cov_209l5tj3cs.s[33]++;
        return action;
      } else {
        cov_209l5tj3cs.b[4][1]++;
      }

      cov_209l5tj3cs.s[34]++;

      if (typeof action === 'function') {
        cov_209l5tj3cs.b[5][0]++;
        cov_209l5tj3cs.s[35]++;
        return action(file);
      } else {
        cov_209l5tj3cs.b[5][1]++;
      }

      cov_209l5tj3cs.s[36]++;
      return '';
    }
  }, {
    key: "validatorHandle",
    value: function validatorHandle(error, file) {
      cov_209l5tj3cs.f[8]++;

      var _ref3 = (cov_209l5tj3cs.s[37]++, this.props),
          vth = _ref3.validatorHandle;

      cov_209l5tj3cs.s[38]++;

      if (typeof vth === 'function') {
        cov_209l5tj3cs.b[6][0]++;
        cov_209l5tj3cs.s[39]++;
        return vth(error, file);
      } else {
        cov_209l5tj3cs.b[6][1]++;
      }

      cov_209l5tj3cs.s[40]++;
      return !!vth;
    }
  }, {
    key: "bindElement",
    value: function bindElement(input) {
      cov_209l5tj3cs.f[9]++;
      cov_209l5tj3cs.s[41]++;
      this.input = input;
    }
  }, {
    key: "handleAddClick",
    value: function handleAddClick() {
      cov_209l5tj3cs.f[10]++;

      var _ref4 = (cov_209l5tj3cs.s[42]++, this.props),
          disabled = _ref4.disabled;

      cov_209l5tj3cs.s[43]++;

      if (disabled) {
        cov_209l5tj3cs.b[7][0]++;
        cov_209l5tj3cs.s[44]++;
        return;
      } else {
        cov_209l5tj3cs.b[7][1]++;
      }

      cov_209l5tj3cs.s[45]++;
      this.input.click();
    }
  }, {
    key: "validate",
    value: function validate() {
      cov_209l5tj3cs.f[11]++;

      var _ref5 = (cov_209l5tj3cs.s[46]++, this.state),
          files = _ref5.files;

      cov_209l5tj3cs.s[47]++;
      return new Promise(function (resolve, reject) {
        cov_209l5tj3cs.f[12]++;
        cov_209l5tj3cs.s[48]++;

        if (Object.keys(files).length > 0) {
          cov_209l5tj3cs.b[8][0]++;
          cov_209l5tj3cs.s[49]++;
          reject(new FormError(''));
        } else {
          cov_209l5tj3cs.b[8][1]++;
        }

        cov_209l5tj3cs.s[50]++;
        resolve(true);
      });
    }
  }, {
    key: "removeFile",
    value: function removeFile(id) {
      cov_209l5tj3cs.f[13]++;

      var _ref6 = (cov_209l5tj3cs.s[51]++, this.props),
          beforeCancel = _ref6.beforeCancel,
          onErrorRemove = _ref6.onErrorRemove;

      var file = (cov_209l5tj3cs.s[52]++, this.state.files[id]);
      cov_209l5tj3cs.s[53]++;

      if ((cov_209l5tj3cs.b[10][0]++, beforeCancel) && (cov_209l5tj3cs.b[10][1]++, isFunc(beforeCancel))) {
        cov_209l5tj3cs.b[9][0]++;
        cov_209l5tj3cs.s[54]++;
        beforeCancel(file);
      } else {
        cov_209l5tj3cs.b[9][1]++;
      }

      cov_209l5tj3cs.s[55]++;

      if (file) {
        cov_209l5tj3cs.b[11][0]++;
        cov_209l5tj3cs.s[56]++;

        if ((cov_209l5tj3cs.b[13][0]++, file.xhr) && (cov_209l5tj3cs.b[13][1]++, file.xhr.abort)) {
          cov_209l5tj3cs.b[12][0]++;
          cov_209l5tj3cs.s[57]++;
          file.xhr.abort();
        } else {
          cov_209l5tj3cs.b[12][1]++;
        }

        cov_209l5tj3cs.s[58]++;
        this.setState(immer(function (draft) {
          cov_209l5tj3cs.f[14]++;
          cov_209l5tj3cs.s[59]++;
          delete draft.files[id];
        }), function () {
          cov_209l5tj3cs.f[15]++;
          cov_209l5tj3cs.s[60]++;

          if ((cov_209l5tj3cs.b[15][0]++, file.status === ERROR) && (cov_209l5tj3cs.b[15][1]++, onErrorRemove)) {
            cov_209l5tj3cs.b[14][0]++;
            cov_209l5tj3cs.s[61]++;
            onErrorRemove(file.xhr, file.blob, file);
          } else {
            cov_209l5tj3cs.b[14][1]++;
          }
        });
      } else {
        cov_209l5tj3cs.b[11][1]++;
      }
    }
  }, {
    key: "removeValue",
    value: function removeValue(index) {
      var _this2 = this;

      cov_209l5tj3cs.f[16]++;

      var _ref7 = (cov_209l5tj3cs.s[62]++, this.props),
          recoverAble = _ref7.recoverAble,
          disabled = _ref7.disabled,
          beforeRemove = _ref7.beforeRemove;

      cov_209l5tj3cs.s[63]++;

      if (disabled) {
        cov_209l5tj3cs.b[16][0]++;
        cov_209l5tj3cs.s[64]++;
        return;
      } else {
        cov_209l5tj3cs.b[16][1]++;
      }

      var current = (cov_209l5tj3cs.s[65]++, this.props.value[index]);
      var startRemove = (cov_209l5tj3cs.s[66]++, typeof beforeRemove === 'function' ? (cov_209l5tj3cs.b[17][0]++, beforeRemove(current)) : (cov_209l5tj3cs.b[17][1]++, Promise.resolve()));
      cov_209l5tj3cs.s[67]++;
      startRemove.then(function () {
        cov_209l5tj3cs.f[17]++;
        cov_209l5tj3cs.s[68]++;

        _this2.setState(immer(function (draft) {
          cov_209l5tj3cs.f[18]++;
          cov_209l5tj3cs.s[69]++;
          draft.recycle.push(_this2.props.value[index]);
          cov_209l5tj3cs.s[70]++;

          if ((cov_209l5tj3cs.b[19][0]++, typeof recoverAble === 'number') && (cov_209l5tj3cs.b[19][1]++, draft.recycle.length > recoverAble)) {
            cov_209l5tj3cs.b[18][0]++;
            cov_209l5tj3cs.s[71]++;
            draft.recycle.shift();
          } else {
            cov_209l5tj3cs.b[18][1]++;
          }
        }));

        var value = (cov_209l5tj3cs.s[72]++, immer(_this2.props.value, function (draft) {
          cov_209l5tj3cs.f[19]++;
          cov_209l5tj3cs.s[73]++;
          draft.splice(index, 1);
        }));
        cov_209l5tj3cs.s[74]++;

        _this2.props.onChange(value);
      })["catch"](function () {
        cov_209l5tj3cs.f[20]++;
      });
    }
  }, {
    key: "recoverValue",
    value: function recoverValue(index, value) {
      cov_209l5tj3cs.f[21]++;

      var _ref8 = (cov_209l5tj3cs.s[75]++, this.props),
          disabled = _ref8.disabled;

      cov_209l5tj3cs.s[76]++;

      if (disabled) {
        cov_209l5tj3cs.b[20][0]++;
        cov_209l5tj3cs.s[77]++;
        return;
      } else {
        cov_209l5tj3cs.b[20][1]++;
      }

      cov_209l5tj3cs.s[78]++;
      this.props.onChange(immer(this.props.value, function (draft) {
        cov_209l5tj3cs.f[22]++;
        cov_209l5tj3cs.s[79]++;
        draft.push(value);
      }));
      cov_209l5tj3cs.s[80]++;
      this.setState(immer(function (draft) {
        cov_209l5tj3cs.f[23]++;
        cov_209l5tj3cs.s[81]++;
        draft.recycle.splice(index, 1);
      }));
    }
  }, {
    key: "useValidator",
    value: function () {
      var _useValidator = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(blob) {
        var _ref9, validator, accept, forceAccept, forceAcceptErrorMsg, _ref10, files, error, i, acceptRes, item;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cov_209l5tj3cs.f[24]++;
                _ref9 = (cov_209l5tj3cs.s[82]++, this.props), validator = _ref9.validator, accept = _ref9.accept, forceAccept = _ref9.forceAccept, forceAcceptErrorMsg = _ref9.forceAcceptErrorMsg;
                _ref10 = (cov_209l5tj3cs.s[83]++, this.state), files = _ref10.files;
                error = (cov_209l5tj3cs.s[84]++, null);
                i = (cov_209l5tj3cs.s[85]++, 0);
                cov_209l5tj3cs.s[86]++;

                if (!forceAccept) {
                  _context.next = 19;
                  break;
                }

                cov_209l5tj3cs.b[21][0]++;
                acceptRes = (cov_209l5tj3cs.s[87]++, attrAccept(blob, accept));
                cov_209l5tj3cs.s[88]++;

                if (acceptRes) {
                  _context.next = 16;
                  break;
                }

                cov_209l5tj3cs.b[22][0]++;
                cov_209l5tj3cs.s[89]++;
                return _context.abrupt("return", new Error((cov_209l5tj3cs.b[23][0]++, forceAcceptErrorMsg) || (cov_209l5tj3cs.b[23][1]++, getLocale('invalidAccept'))));

              case 16:
                cov_209l5tj3cs.b[22][1]++;

              case 17:
                _context.next = 20;
                break;

              case 19:
                cov_209l5tj3cs.b[21][1]++;

              case 20:
                cov_209l5tj3cs.s[90]++;

              case 21:
                if (!VALIDATORITEMS[i]) {
                  _context.next = 52;
                  break;
                }

                item = (cov_209l5tj3cs.s[91]++, VALIDATORITEMS[i]);
                cov_209l5tj3cs.s[92]++;

                if (!((cov_209l5tj3cs.b[25][0]++, validator) && (cov_209l5tj3cs.b[25][1]++, typeof validator[item.key] === 'function'))) {
                  _context.next = 47;
                  break;
                }

                cov_209l5tj3cs.b[24][0]++;
                cov_209l5tj3cs.s[93]++;
                _context.prev = 27;
                cov_209l5tj3cs.s[94]++;
                _context.next = 31;
                return promised(validator[item.key], item.param(blob), files);

              case 31:
                _context.next = 37;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](27);
                cov_209l5tj3cs.s[95]++;
                error = _context.t0 instanceof Error ? (cov_209l5tj3cs.b[26][0]++, _context.t0) : (cov_209l5tj3cs.b[26][1]++, new Error(_context.t0));

              case 37:
                cov_209l5tj3cs.s[96]++;

                if (!(error instanceof Error)) {
                  _context.next = 44;
                  break;
                }

                cov_209l5tj3cs.b[27][0]++;
                cov_209l5tj3cs.s[97]++;
                return _context.abrupt("return", error);

              case 44:
                cov_209l5tj3cs.b[27][1]++;

              case 45:
                _context.next = 48;
                break;

              case 47:
                cov_209l5tj3cs.b[24][1]++;

              case 48:
                cov_209l5tj3cs.s[98]++;
                i += 1;
                _context.next = 21;
                break;

              case 52:
                cov_209l5tj3cs.s[99]++;
                return _context.abrupt("return", null);

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[27, 33]]);
      }));

      function useValidator(_x) {
        return _useValidator.apply(this, arguments);
      }

      return useValidator;
    }()
  }, {
    key: "addFile",
    value: function () {
      var _addFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(e) {
        var _this3 = this;

        var _ref11, beforeUpload, value, _ref11$limit, limit, filesFilter, files, finishedCode, fileList, addLength, list, _loop, i, _ret;

        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cov_209l5tj3cs.f[25]++;
                _ref11 = (cov_209l5tj3cs.s[100]++, this.props), beforeUpload = _ref11.beforeUpload, value = _ref11.value, _ref11$limit = _ref11.limit, limit = _ref11$limit === void 0 ? (cov_209l5tj3cs.b[28][0]++, DefaultProps.limit) : _ref11$limit, filesFilter = _ref11.filesFilter; // eslint-disable-next-line

                files = (cov_209l5tj3cs.s[101]++, _objectSpread2({}, this.state.files));
                finishedCode = (cov_209l5tj3cs.s[102]++, false);
                fileList = (cov_209l5tj3cs.s[103]++, (cov_209l5tj3cs.b[29][0]++, (cov_209l5tj3cs.b[31][0]++, e.fromDragger) && (cov_209l5tj3cs.b[31][1]++, e.files) ? (cov_209l5tj3cs.b[30][0]++, e.files) : (cov_209l5tj3cs.b[30][1]++, (cov_209l5tj3cs.b[32][0]++, e.target) && (cov_209l5tj3cs.b[32][1]++, e.target.files))) || (cov_209l5tj3cs.b[29][1]++, []));
                cov_209l5tj3cs.s[104]++;

                if (filesFilter) {
                  cov_209l5tj3cs.b[33][0]++;
                  cov_209l5tj3cs.s[105]++;
                  fileList = (cov_209l5tj3cs.b[34][0]++, filesFilter(Array.from(fileList))) || (cov_209l5tj3cs.b[34][1]++, []);
                } else {
                  cov_209l5tj3cs.b[33][1]++;
                }

                addLength = (cov_209l5tj3cs.s[106]++, limit - value.length - Object.keys(this.state.files).length);
                cov_209l5tj3cs.s[107]++;

                if (!(addLength <= 0)) {
                  _context3.next = 15;
                  break;
                }

                cov_209l5tj3cs.b[35][0]++;
                cov_209l5tj3cs.s[108]++;
                return _context3.abrupt("return");

              case 15:
                cov_209l5tj3cs.b[35][1]++;

              case 16:
                list = (cov_209l5tj3cs.s[109]++, Array.from({
                  length: Math.min(fileList.length, addLength)
                }));
                cov_209l5tj3cs.s[110]++;
                _loop =
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _loop(i) {
                  var blob, id, file, error;
                  return _regeneratorRuntime.wrap(function _loop$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          blob = (cov_209l5tj3cs.s[111]++, fileList[i]);
                          id = (cov_209l5tj3cs.s[112]++, getUidStr());
                          file = (cov_209l5tj3cs.s[113]++, {
                            name: blob.name,
                            process: -1,
                            status: UPLOADING,
                            blob: blob
                          });
                          cov_209l5tj3cs.s[114]++;
                          files[id] = file; // eslint-disable-next-line no-await-in-loop

                          cov_209l5tj3cs.s[115]++;
                          _context2.next = 8;
                          return _this3.useValidator(blob);

                        case 8:
                          error = _context2.sent;
                          cov_209l5tj3cs.s[116]++;

                          if (!(error instanceof Error)) {
                            _context2.next = 32;
                            break;
                          }

                          cov_209l5tj3cs.b[36][0]++;
                          cov_209l5tj3cs.s[117]++;

                          if (_this3.validatorHandle(error, file.blob)) {
                            _context2.next = 21;
                            break;
                          }

                          cov_209l5tj3cs.b[37][0]++;
                          cov_209l5tj3cs.s[118]++;
                          delete files[id];
                          cov_209l5tj3cs.s[119]++;
                          return _context2.abrupt("return", "continue");

                        case 21:
                          cov_209l5tj3cs.b[37][1]++;

                        case 22:
                          cov_209l5tj3cs.s[120]++;
                          file.message = error.message;
                          cov_209l5tj3cs.s[121]++;
                          file.status = ERROR;
                          cov_209l5tj3cs.s[122]++;

                          if (beforeUpload) {
                            cov_209l5tj3cs.b[38][0]++;
                            cov_209l5tj3cs.s[123]++;
                            beforeUpload(blob, _this3.validatorHandle) // eslint-disable-next-line no-loop-func
                            .then(function (args) {
                              cov_209l5tj3cs.f[26]++;
                              cov_209l5tj3cs.s[124]++;

                              if (finishedCode) {
                                cov_209l5tj3cs.b[39][0]++;
                                cov_209l5tj3cs.s[125]++;

                                _this3.setState(immer(function (draft) {
                                  cov_209l5tj3cs.f[27]++;
                                  cov_209l5tj3cs.s[126]++;
                                  draft.files[id] = Object.assign({}, draft.files[id], args);
                                }));
                              } else {
                                cov_209l5tj3cs.b[39][1]++;
                                cov_209l5tj3cs.s[127]++;
                                files[id] = Object.assign({}, files[id], args);
                              }
                            })["catch"](function () {
                              cov_209l5tj3cs.f[28]++;
                              cov_209l5tj3cs.s[128]++;
                              return true;
                            });
                          } else {
                            cov_209l5tj3cs.b[38][1]++;
                          }

                          cov_209l5tj3cs.s[129]++;
                          return _context2.abrupt("return", "continue");

                        case 32:
                          cov_209l5tj3cs.b[36][1]++;

                        case 33:
                          cov_209l5tj3cs.s[130]++;

                          if (beforeUpload) {
                            cov_209l5tj3cs.b[40][0]++;
                            cov_209l5tj3cs.s[131]++;
                            beforeUpload(blob, _this3.validatorHandle) // eslint-disable-next-line no-loop-func
                            .then(function (args) {
                              cov_209l5tj3cs.f[29]++;
                              cov_209l5tj3cs.s[132]++;

                              if (args.status !== ERROR) {
                                cov_209l5tj3cs.b[41][0]++;
                                cov_209l5tj3cs.s[133]++;
                                files[id].xhr = _this3.uploadFile(id, blob, args.data);
                              } else {
                                cov_209l5tj3cs.b[41][1]++;
                              }

                              cov_209l5tj3cs.s[134]++;

                              if (finishedCode) {
                                cov_209l5tj3cs.b[42][0]++;
                                cov_209l5tj3cs.s[135]++;

                                _this3.setState(immer(function (draft) {
                                  cov_209l5tj3cs.f[30]++;
                                  cov_209l5tj3cs.s[136]++;
                                  draft.files[id] = Object.assign({}, draft.files[id], args);
                                }));
                              } else {
                                cov_209l5tj3cs.b[42][1]++;
                                cov_209l5tj3cs.s[137]++;
                                files[id] = Object.assign({}, files[id], args);
                              }
                            }) // eslint-disable-next-line no-loop-func
                            ["catch"](function () {
                              cov_209l5tj3cs.f[31]++;
                              cov_209l5tj3cs.s[138]++;

                              if (finishedCode) {
                                cov_209l5tj3cs.b[43][0]++;
                                cov_209l5tj3cs.s[139]++;

                                _this3.setState(immer(function (draft) {
                                  cov_209l5tj3cs.f[32]++;
                                  cov_209l5tj3cs.s[140]++;
                                  delete draft.files[id];
                                }));
                              } else {
                                cov_209l5tj3cs.b[43][1]++;
                                cov_209l5tj3cs.s[141]++;
                                delete files[id];
                              }
                            });
                          } else {
                            cov_209l5tj3cs.b[40][1]++;
                            cov_209l5tj3cs.s[142]++;
                            files[id].xhr = _this3.uploadFile(id, blob);
                          }

                        case 35:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _loop);
                });
                i = 0;

              case 20:
                if (!(i < list.length)) {
                  _context3.next = 28;
                  break;
                }

                return _context3.delegateYield(_loop(i), "t0", 22);

              case 22:
                _ret = _context3.t0;

                if (!(_ret === "continue")) {
                  _context3.next = 25;
                  break;
                }

                return _context3.abrupt("continue", 25);

              case 25:
                i++;
                _context3.next = 20;
                break;

              case 28:
                cov_209l5tj3cs.s[143]++;
                finishedCode = true;
                cov_209l5tj3cs.s[144]++;
                this.setState({
                  files: files
                });

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function addFile(_x2) {
        return _addFile.apply(this, arguments);
      }

      return addFile;
    }()
  }, {
    key: "uploadFile",
    value: function uploadFile(id, file, data) {
      var _this4 = this;

      cov_209l5tj3cs.f[33]++;

      var _ref12 = (cov_209l5tj3cs.s[145]++, this.props),
          onSuccess = _ref12.onSuccess,
          name = _ref12.name,
          htmlName = _ref12.htmlName,
          cors = _ref12.cors,
          params = _ref12.params,
          withCredentials = _ref12.withCredentials,
          headers = _ref12.headers,
          request = _ref12.request,
          _onProgress = _ref12.onProgress,
          onStart = _ref12.onStart,
          responseType = _ref12.responseType;

      var req = (cov_209l5tj3cs.s[146]++, (cov_209l5tj3cs.b[44][0]++, request) || (cov_209l5tj3cs.b[44][1]++, defaultRequest));
      var throttle = (cov_209l5tj3cs.s[147]++, false);
      var options = (cov_209l5tj3cs.s[148]++, {
        url: this.getAction(file),
        name: (cov_209l5tj3cs.b[45][0]++, htmlName) || (cov_209l5tj3cs.b[45][1]++, name),
        cors: cors,
        params: params,
        withCredentials: withCredentials,
        file: file,
        headers: headers,
        responseType: responseType,
        onStart: onStart,
        onProgress: function onProgress(e, msg) {
          cov_209l5tj3cs.f[34]++;
          var percent = (cov_209l5tj3cs.s[149]++, typeof e.percent === 'number' ? (cov_209l5tj3cs.b[46][0]++, e.percent) : (cov_209l5tj3cs.b[46][1]++, e.loaded / e.total * 100));
          cov_209l5tj3cs.s[150]++;

          if (throttle) {
            cov_209l5tj3cs.b[47][0]++;
            cov_209l5tj3cs.s[151]++;
            return;
          } else {
            cov_209l5tj3cs.b[47][1]++;
          }

          cov_209l5tj3cs.s[152]++;
          throttle = true;
          cov_209l5tj3cs.s[153]++;
          setTimeout(function () {
            cov_209l5tj3cs.f[35]++;
            cov_209l5tj3cs.s[154]++;
            throttle = false;
          }, 16);
          cov_209l5tj3cs.s[155]++;

          if (_this4.state.files[id]) {
            cov_209l5tj3cs.b[48][0]++;
            cov_209l5tj3cs.s[156]++;

            _this4.setState(immer(function (draft) {
              cov_209l5tj3cs.f[36]++;
              cov_209l5tj3cs.s[157]++;
              draft.files[id].process = percent;
              cov_209l5tj3cs.s[158]++;

              if (msg) {
                cov_209l5tj3cs.b[49][0]++;
                cov_209l5tj3cs.s[159]++;
                draft.files[id].message = msg;
              } else {
                cov_209l5tj3cs.b[49][1]++;
              }
            }), // expose the file progress to Upload.Button
            function () {
              cov_209l5tj3cs.f[37]++;
              cov_209l5tj3cs.s[160]++;

              if (typeof _onProgress === 'function') {
                cov_209l5tj3cs.b[50][0]++;
                cov_209l5tj3cs.s[161]++;

                _onProgress(_this4.state.files[id]);
              } else {
                cov_209l5tj3cs.b[50][1]++;
              }
            });
          } else {
            cov_209l5tj3cs.b[48][1]++;
          }
        },
        onSuccess: onSuccess,
        onLoad: function onLoad(xhr) {
          cov_209l5tj3cs.f[38]++;
          cov_209l5tj3cs.s[162]++;

          if (!/^2|1223/.test("".concat(xhr.status))) {
            cov_209l5tj3cs.b[51][0]++;
            cov_209l5tj3cs.s[163]++;

            _this4.handleError(id, xhr, file);

            cov_209l5tj3cs.s[164]++;
            return;
          } else {
            cov_209l5tj3cs.b[51][1]++;
          }

          var value;
          cov_209l5tj3cs.s[165]++;

          if ((cov_209l5tj3cs.b[53][0]++, xhr.responseType === 'text') || (cov_209l5tj3cs.b[53][1]++, !xhr.responseType)) {
            cov_209l5tj3cs.b[52][0]++;
            cov_209l5tj3cs.s[166]++;
            value = xhr.responseText;
          } else {
            cov_209l5tj3cs.b[52][1]++;
          }

          cov_209l5tj3cs.s[167]++;

          if (!value) {
            cov_209l5tj3cs.b[54][0]++;
            cov_209l5tj3cs.s[168]++;
            value = xhr.response;
          } else {
            cov_209l5tj3cs.b[54][1]++;
          }

          cov_209l5tj3cs.s[169]++;

          if (onSuccess) {
            cov_209l5tj3cs.b[55][0]++;
            cov_209l5tj3cs.s[170]++;
            value = onSuccess(value, file, data, xhr);
          } else {
            cov_209l5tj3cs.b[55][1]++;
          }

          cov_209l5tj3cs.s[171]++;

          if (value instanceof Error) {
            cov_209l5tj3cs.b[56][0]++;
            cov_209l5tj3cs.s[172]++;

            _this4.setState(immer(function (draft) {
              cov_209l5tj3cs.f[39]++;
              cov_209l5tj3cs.s[173]++;
              draft.files[id].status = ERROR;
              cov_209l5tj3cs.s[174]++;
              draft.files[id].name = file.name;
              cov_209l5tj3cs.s[175]++;
              draft.files[id].message = value.message;
            }));
          } else {
            cov_209l5tj3cs.b[56][1]++;
            cov_209l5tj3cs.s[176]++;

            _this4.setState(immer(function (draft) {
              cov_209l5tj3cs.f[40]++;
              cov_209l5tj3cs.s[177]++;
              delete draft.files[id];
            })); // add value


            var values = (cov_209l5tj3cs.s[178]++, immer(_this4.props.value, function (draft) {
              cov_209l5tj3cs.f[41]++;
              cov_209l5tj3cs.s[179]++;
              draft.push(value);
            }));
            cov_209l5tj3cs.s[180]++;

            _this4.props.onChange(values);
          }
        },
        onError: function onError(xhr) {
          cov_209l5tj3cs.f[42]++;
          cov_209l5tj3cs.s[181]++;
          return _this4.handleError(id, xhr, file);
        }
      });
      cov_209l5tj3cs.s[182]++;

      if ((cov_209l5tj3cs.b[58][0]++, _onProgress === false) || (cov_209l5tj3cs.b[58][1]++, _onProgress === null)) {
        cov_209l5tj3cs.b[57][0]++;
        cov_209l5tj3cs.s[183]++;

        options.onProgress = function () {
          cov_209l5tj3cs.f[43]++;
        };
      } else {
        cov_209l5tj3cs.b[57][1]++;
      }

      cov_209l5tj3cs.s[184]++;
      return req(options);
    }
  }, {
    key: "handleFileDrop",
    value: function handleFileDrop(files) {
      cov_209l5tj3cs.f[44]++;
      cov_209l5tj3cs.s[185]++;
      this.addFile({
        files: files,
        fromDragger: true
      });
    }
  }, {
    key: "handleReplace",
    value: function handleReplace(files, index) {
      var _this5 = this;

      cov_209l5tj3cs.f[45]++;
      cov_209l5tj3cs.s[186]++;
      this.removeValue(index);
      cov_209l5tj3cs.s[187]++;
      setTimeout(function () {
        cov_209l5tj3cs.f[46]++;
        cov_209l5tj3cs.s[188]++;

        _this5.addFile({
          files: files,
          fromDragger: true
        });
      });
    }
  }, {
    key: "handleError",
    value: function handleError(id, xhr, file) {
      cov_209l5tj3cs.f[47]++;

      var _ref13 = (cov_209l5tj3cs.s[189]++, this.props),
          onError = _ref13.onError,
          onHttpError = _ref13.onHttpError;

      var message = (cov_209l5tj3cs.s[190]++, xhr.statusText);
      cov_209l5tj3cs.s[191]++;

      if (onError) {
        cov_209l5tj3cs.b[59][0]++;
        cov_209l5tj3cs.s[192]++;
        message = onError(xhr, file);
      } else {
        cov_209l5tj3cs.b[59][1]++;
      }

      cov_209l5tj3cs.s[193]++;

      if (onHttpError) {
        cov_209l5tj3cs.b[60][0]++;
        cov_209l5tj3cs.s[194]++;
        message = (cov_209l5tj3cs.b[61][0]++, onHttpError(xhr, file)) || (cov_209l5tj3cs.b[61][1]++, message);
      } else {
        cov_209l5tj3cs.b[60][1]++;
      }

      cov_209l5tj3cs.s[195]++;
      this.setState(immer(function (draft) {
        cov_209l5tj3cs.f[48]++;
        cov_209l5tj3cs.s[196]++;

        if (!draft.files[id]) {
          cov_209l5tj3cs.b[62][0]++;
          cov_209l5tj3cs.s[197]++;
          return;
        } else {
          cov_209l5tj3cs.b[62][1]++;
        }

        cov_209l5tj3cs.s[198]++;
        draft.files[id].status = ERROR;
        cov_209l5tj3cs.s[199]++;
        draft.files[id].message = message;
      }));
    }
  }, {
    key: "renderHandle",
    value: function renderHandle() {
      cov_209l5tj3cs.f[49]++;

      var _ref14 = (cov_209l5tj3cs.s[200]++, this.props),
          _ref14$limit = _ref14.limit,
          limit = _ref14$limit === void 0 ? (cov_209l5tj3cs.b[63][0]++, DefaultProps.limit) : _ref14$limit,
          value = _ref14.value,
          children = _ref14.children,
          accept = _ref14.accept,
          multiple = _ref14.multiple,
          disabled = _ref14.disabled,
          webkitdirectory = _ref14.webkitdirectory,
          drop = _ref14.drop;

      var count = (cov_209l5tj3cs.s[201]++, value.length + Object.keys(this.state.files).length);
      cov_209l5tj3cs.s[202]++;

      if ((cov_209l5tj3cs.b[65][0]++, limit > 0) && (cov_209l5tj3cs.b[65][1]++, limit <= count)) {
        cov_209l5tj3cs.b[64][0]++;
        cov_209l5tj3cs.s[203]++;
        return null;
      } else {
        cov_209l5tj3cs.b[64][1]++;
      }

      var dragProps = (cov_209l5tj3cs.s[204]++, {
        multiple: multiple,
        addFile: this.addFile,
        accept: accept,
        disabled: disabled,
        limit: limit
      });
      cov_209l5tj3cs.s[205]++;
      return (
        /*#__PURE__*/
        React.createElement(Drop, {
          drop: drop,
          accept: accept,
          disabled: disabled,
          onDrop: this.handleFileDrop,
          multiple: (cov_209l5tj3cs.b[66][0]++, !!multiple) || (cov_209l5tj3cs.b[66][1]++, limit > 1),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 458,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: uploadClass('handle', (cov_209l5tj3cs.b[67][0]++, disabled) && (cov_209l5tj3cs.b[67][1]++, 'disabled')),
          onClick: this.handleAddClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 465,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: dragProps,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 466,
            columnNumber: 11
          }
        }, children),
        /*#__PURE__*/
        React.createElement(FileInput, {
          webkitdirectory: webkitdirectory,
          accept: accept,
          ref: this.bindElement,
          multiple: multiple,
          onChange: this.addFile,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 467,
            columnNumber: 11
          }
        })))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      cov_209l5tj3cs.f[50]++;

      var _ref15 = (cov_209l5tj3cs.s[206]++, this.props),
          _ref15$limit = _ref15.limit,
          limit = _ref15$limit === void 0 ? (cov_209l5tj3cs.b[68][0]++, DefaultProps.limit) : _ref15$limit,
          value = _ref15.value,
          renderResult = _ref15.renderResult,
          style = _ref15.style,
          imageStyle = _ref15.imageStyle,
          recoverAble = _ref15.recoverAble,
          showUploadList = _ref15.showUploadList,
          CustomResult = _ref15.customResult,
          disabled = _ref15.disabled,
          renderContent = _ref15.renderContent,
          accept = _ref15.accept,
          drop = _ref15.drop,
          leftHandler = _ref15.leftHandler,
          onPreview = _ref15.onPreview,
          removeConfirm = _ref15.removeConfirm,
          gapProps = _ref15.gapProps;

      var _ref16 = (cov_209l5tj3cs.s[207]++, this.state),
          files = _ref16.files,
          recycle = _ref16.recycle;

      var fileDrop = (cov_209l5tj3cs.s[208]++, (cov_209l5tj3cs.b[69][0]++, drop) && (cov_209l5tj3cs.b[69][1]++, !imageStyle));
      var className = (cov_209l5tj3cs.s[209]++, classnames(uploadClass('_', (cov_209l5tj3cs.b[70][0]++, isRTL()) && (cov_209l5tj3cs.b[70][1]++, 'rtl'), (cov_209l5tj3cs.b[71][0]++, disabled) && (cov_209l5tj3cs.b[71][1]++, 'disabled'), (cov_209l5tj3cs.b[72][0]++, showUploadList === false) && (cov_209l5tj3cs.b[72][1]++, 'hide-list'), (cov_209l5tj3cs.b[73][0]++, fileDrop) && (cov_209l5tj3cs.b[73][1]++, 'file-drop')), this.props.className));
      var FileComponent = (cov_209l5tj3cs.s[210]++, imageStyle ? (cov_209l5tj3cs.b[74][0]++, ImageFile) : (cov_209l5tj3cs.b[74][1]++, FileContent));
      var ResultComponent = (cov_209l5tj3cs.s[211]++, imageStyle ? (cov_209l5tj3cs.b[75][0]++, ImageResult) : (cov_209l5tj3cs.b[75][1]++, Result));
      cov_209l5tj3cs.s[212]++;

      if (CustomResult) {
        cov_209l5tj3cs.b[76][0]++;
        cov_209l5tj3cs.s[213]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: className,
            style: style,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 516,
              columnNumber: 9
            }
          }, this.renderHandle(),
          /*#__PURE__*/
          React.createElement(CustomResult, {
            value: value,
            files: files,
            onValueRemove: this.removeValue,
            onFileRemove: this.removeFile,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 518,
              columnNumber: 11
            }
          }))
        );
      } else {
        cov_209l5tj3cs.b[76][1]++;
      }

      var Wrapper = (cov_209l5tj3cs.s[214]++, imageStyle ? (cov_209l5tj3cs.b[77][0]++, Gap) : (cov_209l5tj3cs.b[77][1]++, React.Fragment));
      cov_209l5tj3cs.s[215]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 526,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement(Wrapper, Object.assign({}, imageStyle ? (cov_209l5tj3cs.b[78][0]++, gapProps) : (cov_209l5tj3cs.b[78][1]++, null), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 527,
            columnNumber: 9
          }
        }), (cov_209l5tj3cs.b[79][0]++, !imageStyle) && (cov_209l5tj3cs.b[79][1]++, this.renderHandle()), (cov_209l5tj3cs.b[80][0]++, imageStyle) && (cov_209l5tj3cs.b[80][1]++, leftHandler) && (cov_209l5tj3cs.b[80][2]++, this.renderHandle()), (cov_209l5tj3cs.b[81][0]++, showUploadList) && (cov_209l5tj3cs.b[81][1]++, value.map(function (v, i) {
          cov_209l5tj3cs.f[51]++;
          cov_209l5tj3cs.s[216]++;
          return (
            /*#__PURE__*/
            React.createElement(Drop, {
              drop: drop,
              multiple: false,
              key: i,
              accept: accept,
              dropData: i,
              disabled: disabled,
              onDrop: _this6.handleReplace,
              __self: _this6,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 532,
                columnNumber: 15
              }
            },
            /*#__PURE__*/
            React.createElement(ResultComponent, {
              renderContent: renderContent,
              value: v,
              values: value,
              index: i,
              style: imageStyle,
              renderResult: renderResult,
              onRemove: _this6.getCanDelete(v, i) ? (cov_209l5tj3cs.b[82][0]++, _this6.removeValue) : (cov_209l5tj3cs.b[82][1]++, undefined),
              removeConfirm: removeConfirm,
              onPreview: onPreview,
              __self: _this6,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 541,
                columnNumber: 17
              }
            }))
          );
        })), (cov_209l5tj3cs.b[83][0]++, showUploadList) && (cov_209l5tj3cs.b[83][1]++, Object.keys(files).map(function (id) {
          cov_209l5tj3cs.f[52]++;
          cov_209l5tj3cs.s[217]++;
          return (
            /*#__PURE__*/
            React.createElement(FileComponent, Object.assign({}, files[id], {
              key: id,
              id: id,
              style: imageStyle,
              onRemove: _this6.removeFile,
              __self: _this6,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 557,
                columnNumber: 15
              }
            }))
          );
        })), (cov_209l5tj3cs.b[84][0]++, imageStyle) && (cov_209l5tj3cs.b[84][1]++, !leftHandler) && (cov_209l5tj3cs.b[84][2]++, this.renderHandle()), (cov_209l5tj3cs.b[85][0]++, recoverAble) && (cov_209l5tj3cs.b[85][1]++, recycle.map(function (v, i) {
          cov_209l5tj3cs.f[53]++;
          cov_209l5tj3cs.s[218]++;
          return (
            /*#__PURE__*/
            React.createElement(ResultComponent, {
              renderContent: renderContent,
              key: i,
              value: v,
              values: recycle,
              index: i,
              renderResult: renderResult,
              recoverAble: !!recoverAble,
              showRecover: (cov_209l5tj3cs.b[86][0]++, recoverAble) && (cov_209l5tj3cs.b[86][1]++, limit > value.length),
              onRecover: _this6.recoverValue,
              style: imageStyle,
              __self: _this6,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 564,
                columnNumber: 15
              }
            })
          );
        }))))
      );
    }
  }]);

  return Upload;
}(PureComponent);

Upload.defaultProps = DefaultProps;
export default acceptHOC(Upload);